import request from '@/utils/request';
// import { getToken } from '@/utils/auth';
import ENVIRONMENT from '@/utils/environment';
/**
 *   获取积分明细列表
 * @method getFetchPointsList
 * @return { request } axsio请求封装
 */
export function getStatementQueryList(params) {
  return request({
    url: `/orderchecks/page-list`,
    method: 'get',
    params: params
  });
}
export function getGoodsSkuList(params) {
  return request({
    url: `/goods/sku`,
    method: 'get',
    params: params
  });
}
export function getGoodsQuerySku(params) {
  return request({
    url: `goods/querySku`,
    method: 'get',
    params: params
  });
}
export function getGoodsSuitesList(params) {
  return request({
    url: `/goods/suites`,
    method: 'get',
    params: params
  });
}
export function getGoodsAdd(option) {
  return request({
    url: `/goods/`,
    method: 'post',
    data: option
  });
}
export function getGoodsEdit(option) {
  return request({
    url: `/goods/`,
    method: 'put',
    data: option
  });
}
export function getGoodsDel(id, option) {
  return request({
    url: `/goods/${id}`,
    method: 'delete',
    params: option
  });
}
export function getGoodsDetails(id) {
  return request({
    url: `/goods/${id}`,
    method: 'get'
  });
}

export function getGoodsThirdList(params) {
  return request({
    url: `/orderchecks/third`,
    method: 'get',
    params: params
  });
}
export function getGoodsPageList(params) {
  return request({
    url: `/goods/page-list`,
    method: 'get',
    params: params
  });
}
// 查询用户收货地址
export function getUsersAddressList(params) {
  return request({
    url: `/users/address`,
    method: 'get',
    params: params
  });
}
// 获取用户积分明细
export function getIntegralList(params) {
  return request({
    url: `/users/integral-detail`,
    method: 'get',
    params: params
  });
}
// 获取用户列表
export function getUsersList(params) {
  return request({
    url: `/users/page-list`,
    method: 'get',
    params: params
  });
}
// 获取用户权益明细
export function getEquityList(params) {
  return request({
    url: `/users/equity-detail`,
    method: 'get',
    params: params
  });
}

// 不同资源厂商的账户余量列表查询
export function getThirdaccountbalances(params) {
  return request({
    url: `/op/thirdaccountbalances/list`,
    method: 'get',
    params: params
  });
}
// 导入吃掉系列会员授权码信息
export function thirdaccountbalancesImprotExcel() {
  return `${ENVIRONMENT.BASE_API}/op/thirdaccountbalances/import/eatvipauthcode`;
}

// 不同资源厂商的账户余量列表查询
export function getViprecords(params) {
  return request({
    url: `/viprecords/page-list`,
    method: 'get',
    params: params
  });
}
// 不同资源厂商的账户余量列表查询
export function getThirdaccountbalancesList(params) {
  return request({
    url: `/op/thirdaccountbalances/equity/page-list`,
    method: 'get',
    params: params
  });
}
// 不同资源厂商的账户余量列表查询
export function getEquityStatistic() {
  return request({
    url: `/op/thirdaccountbalances/equity/statistic`,
    method: 'get'
  });
}
